import * as S from './styles';
import { FmdBadOutlined } from '@mui/icons-material';

export default function NoClassSectionData() {
  return (
    <S.EmptyStateContainer>
      <FmdBadOutlined
        sx={{
          width: 60,
          height: 70,
          color: '#C2C1C1',
        }}
      />

      <S.MessageText>현재 우리학교 생성 분반이 없습니다.</S.MessageText>
      <S.MessageText>
        아래 '분반 만들기' 버튼을 클릭해 분반을 생성해주세요.
      </S.MessageText>
    </S.EmptyStateContainer>
  );
}
